<template>
    <div class="location-details" :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
      <div class="location-image" v-if="params.ImageUrl" ><img :src="params.ImageUrl" style="max-width: 100%; max-height: 100%;"/></div>
      <div class="location-image" v-else><img src="../../../../assets/images/checkin-images/map.jpg" style="max-width: 100%; max-height: 100%;"/></div>
      <div class="location-name"><p>{{ params.Name }}</p></div>
    </div>
  </template>

  <script>
  import Swal from "sweetalert2";
  // Mixins
  import commonMixin from '@/mixins/common'
  export default {
    name: "CellRendererActions",
    mixins: [commonMixin],
    data (){
      return {
        QR: null,
        popupQR: false
      }
    },
    methods: {
      editRecord(id) {
        //console.log(id);
        //id = window.btoa(id);
        this.$router
          .push({
            name: "attendee-edit",
            params: {
              AttendeeId: id,
            },
          })
          .catch(() => {});
      },
      confirmDeleteRecord() {
        const { value: text } = Swal.fire({
          title: "Do you want to Delete these Attendee's ?",
          input: "text",
          inputPlaceholder: "Type 'delete' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase().trim() == "delete") {
              this.deleteRecord();
            } else {
              return "Try again! Please type 'delete' and hit Submit.";
            }
          },
        });
      },
      deleteRecord() {
        /* Below two lines are just for demo purpose */
        //this.showDeleteSuccess()
        this.$vs.loading();
        /* UnComment below lines for enabling true flow if deleting user */
        this.$store
          .dispatch("attendeeManagement/removeRecord", {
            AttendeeId: this.params.id,
            Email: this.params.Email,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$store.dispatch("attendeeManagement/fetchAttendees");
              this.showDeleteSuccess();
            }
          })
          .catch((err) => {
            console.error(err);
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Delete",
              text: err.message,
            });
          });
      },
      showDeleteSuccess() {
        this.$vs.notify({
          color: "success",
          title: "Record Deleted",
          text: "The selected record was successfully deleted",
        });
      },
      showQR(params){
        if(params.QR){
          this.QR = params.QR;
          this.popupQR = true;
        }else{
          this.generateQR(params.id)
        }
      },
      downloadQR(){
        if(this.QR){
          let filename = "QR_Attendee" + "_" + this.QR.substr(this.QR.lastIndexOf("/")); 
          this.downloadImageFromURL(this.QR, filename)
        }
      },
      generateQR(id) {
          this.$vs.loading();
          this.$store
            .dispatch("attendeeManagement/generateQR", [id])
            .then( (res) => {
              for(let item of res.data){
                if(item.status == 0){ 
                  this.QR = item.data.QR;
                }
              }
              this.popupQR = true;      
              this.$vs.loading.close();
            })
            .catch((err) => {
              console.error(err)
              this.$vs.loading.close();
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                text: "Something went wrong!",
              });
            });
        
      },
    },
  };
  </script>
  